import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import TimeslotPopover from "../timeslot-popover/timeslot-popover";
import moment from "moment";
import util from "../util/util";
import DatePicker from "react-datepicker";
import ReportsSearchDate from "../reports/reports-search-date";

export default function ScheduleByWeekSchedule(props) {
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  const [startDate, setStartDate] = useState(moment(props.sunday));
  const [endDate, setEndDate] = useState(moment(props.sunday).add(6, "days"));

  useEffect(() => {
    setStartDate(moment(props.sunday));
    setEndDate(moment(props.sunday).add(6, "days"));
  }, [props.sunday]);

  return (
    <div>
      <div className="text-center schedule-by-week__button--download">
        <button
          className="btn btn-default"
          onClick={() => setShowScheduleForm(!showScheduleForm)}
        >
          <i className="fa fa-cloud-download" aria-hidden="true"></i>
          Export schedule
        </button>
      </div>

      <div className={showScheduleForm ? "form-inline search-form" : "hidden"}>
        <div className="row schedule-by-week__form--top">
          <div className="col-sm-6 text-right">
            <div className="form-group form-inline">
              <label className="control-label">From:</label>
              <div className="reports__button--date">
                <DatePicker
                  popperClassName="reports__datepicker"
                  customInput={
                    <ReportsSearchDate
                      dateDisplay={startDate.format(util.dateFormatHumanLong)}
                    />
                  }
                  fixedHeight
                  selected={startDate}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  onChange={value => {
                    setStartDate(value);
                    // if 'start' if after 'end', changing the 'end' too
                    value.isAfter(endDate) && setEndDate(value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group form-inline">
              <label className="control-label">To:</label>
              <div className="reports__button--date">
                <DatePicker
                  popperClassName="reports__datepicker"
                  customInput={
                    <ReportsSearchDate
                      dateDisplay={endDate.format(util.dateFormatHumanLong)}
                    />
                  }
                  fixedHeight
                  selected={endDate}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  onChange={value => {
                    setEndDate(value);
                    // if 'end' if before 'start', changing the 'start' too
                    value.isBefore(startDate) && setStartDate(value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <p>
              <a
                href={util.getSchedulesInterstitialsCSV(
                  startDate.format(util.dateFormatComputer),
                  endDate.format(util.dateFormatComputer)
                )}
                className="btn btn-default"
              >
                <i className="fa fa-cloud-download" aria-hidden="true"></i>
                Export schedule
              </a>
            </p>
          </div>
        </div>
      </div>

      <ul className="nav nav-tabs schedule-by-week__nav--top">
        <li role="presentation" className="active">
          <a href="#tab1" data-toggle="tab">
            00:00 - 7:30
          </a>
        </li>
        <li role="presentation">
          <a href="#tab2" data-toggle="tab">
            08:00 - 15:30
          </a>
        </li>
        <li role="presentation">
          <a href="#tab3" data-toggle="tab">
            16:00 - 23:30
          </a>
        </li>
      </ul>

      <div className="tab-content">
        <div className="tab-pane active" id="tab1">
          {renderScheduleByIndex(0, 32)}
        </div>
        <div className="tab-pane" id="tab2">
          {renderScheduleByIndex(32, 64)}
        </div>
        <div className="tab-pane" id="tab3">
          {renderScheduleByIndex(64, 96)}
        </div>
      </div>
    </div>
  );

  function renderScheduleByIndex(startIndex, endIndex) {
    const schedule = props.schedule.slice(startIndex, endIndex);
    const returnRowSpan = duration => {
      const durationArray = duration.split(`:`);
      const hours = Number(durationArray[0]);
      const minutes = Number(durationArray[1]);
      let rowspan = hours * 3; // first half hour slot, first half hour slot's interstital slot, second half hour slot;

      // if the show is only X hours long, then no need to add any additional rows;
      // if if the show is 1:30 long, we need 5 rows, not 3;
      if (minutes) {
        rowspan = rowspan + 2;
      }

      return rowspan;
    };

    // before we render the partial schedule, we need to adjust the object to account for rowspans;
    // we do not account for rowspans across tabs (a show running from 7:30 - 8:30 has a rowspan of 1, not 3);
    schedule.map(
      (row, rowIndex) =>
        row.days &&
        row.days.forEach((day, dayIndex) => {
          if (day.content.duration && day.content.duration !== `00:30:00`) {
            const rowSpan = returnRowSpan(day.content.duration);

            day.content.rowSpan = rowSpan;

            // now that we know the rowspan for this show, we need to remove the timeslots from the next X rows so the table lays out properly;
            // start at one row past the current row - otherwise we'd skip the show we want to display;
            for (let i = 1; i < rowSpan; i++) {
              const target = schedule[rowIndex + i];
              if (target) {
                target.days[dayIndex].skip = true;
              }
            }
          }
        })
    );

    return (
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={{ width: `12.5%` }}></col>
            <col style={{ width: `12.5%` }}></col>
            <col style={{ width: `12.5%` }}></col>
            <col style={{ width: `12.5%` }}></col>
            <col style={{ width: `12.5%` }}></col>
            <col style={{ width: `12.5%` }}></col>
            <col style={{ width: `12.5%` }}></col>
            <col style={{ width: `12.5%` }}></col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              {util.days.map((day, i) => {
                const date = moment(props.sunday).add(i, `days`);
                const dateForLink = date.format(util.dateFormatComputer);
                const dateForDisplay = date.format(util.dateFormatHumanShort);

                return (
                  <th key={i}>
                    <Link to={util.returnScheduleDayUrl(dateForLink)}>
                      {dateForDisplay}
                    </Link>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {schedule.map((row, j) => (
              <tr key={j}>
                {row.timeslot && row.timeslot.substr(-1) !== `0` ? (
                  <th>
                    <Link
                      to={util.returnScheduleTimeSlotUrl(
                        row.timeslot,
                        props.sunday
                      )}
                    >
                      {row.timeslot}
                    </Link>
                  </th>
                ) : (
                  <th>{row.timeslot}</th>
                )}
                {row.days &&
                  row.days.map((day, k) => {
                    // determine what kind of content (if any) to show;

                    // skip (meaning a previous show is taking up this timeslot);
                    // this is first because a pod may be assigned to a slot we should skip;
                    // the back-end allows pods to be assigned to invalid slots;
                    if (day.skip) {
                      return null;
                    }
                    // pod;
                    else if (day.content.pod) {
                      return (
                        <td key={k}>
                          <TimeslotPopover
                            pod={day.content.pod}
                            rule={day.content.rule}
                          />
                        </td>
                      );
                    }
                    // show;
                    else if (day.content.show) {
                      return (
                        <td key={k} rowSpan={day.content.rowSpan}>
                          {day.content.show}
                        </td>
                      );
                    }
                    // undefined;
                    else {
                      return <td key={k} />;
                    }
                  })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

ScheduleByWeekSchedule.propTypes = {
  schedule: PropTypes.array, // array used to build the TABLE;
  sunday: PropTypes.string // used to calc the THs;
};
